import { ThemeAttribute } from '@yandex-int/k-common/typings';
import { AttributeFilter } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { ReduxTeacherStore, RootAction } from '../../../typings';
import * as actions from '../../library.store/actions';
import {
    getAvailableFiltersByTheme,
    getFiltersByTheme,
    getFilterValues,
    getShouldShowClearButton,
} from '../../library.store/selectors';

import withUrlFilterListening from './with-url-filter-listening';

interface OwnProps extends WithRouterPathProps {
    mix?: string;
}

interface StoreProps {
    availableFilters: Array<ThemeAttribute>;
    filters: Array<ThemeAttribute>;
    filterValues: Record<string, Array<string> | string>;
    shouldShowClearButton: boolean;
    themeId: number;
}

interface DispatchProps {
    clearFilters: typeof actions.clearFilters;
    changeFilterValue: typeof actions.changeFilterValue;
}

const mapStateToProps = (
    storeState: ReduxTeacherStore,
    {
        match: {
            params: { themeId: thId, subject },
        },
    }: OwnProps
): StoreProps => {
    const themeId = Number(thId);

    return {
        availableFilters: getAvailableFiltersByTheme(storeState, { themeId }),
        filters: getFiltersByTheme(storeState, { themeId, subject, grade: null }),
        filterValues: getFilterValues(storeState),
        shouldShowClearButton: getShouldShowClearButton(storeState),
        themeId,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            applyFilterFromUrl: actions.applyFilterFromUrl,
            clearFilters: actions.clearFilters,
            changeFilterValue: actions.changeFilterValue,
            getAttributesRequest: actions.getAllAttributesRequest,
        },
        dispatch
    );
};

export default withRouterPath(connect(mapStateToProps, mapDispatchToProps)(withUrlFilterListening(AttributeFilter)));
